import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import { Checkbox, Popover } from "@cirrus/legacy/app-components/entries/lib.js"
import styles from "./filter.less"

class Filter extends C {
  constructor(props) {
    super(props)
  }

  static propTypes = {
    data: PropTypes.shape({
      className: PropTypes.string,
      isShown: PropTypes.bool,
      anchor: PropTypes.object,
      container: PropTypes.object,
      title: PropTypes.string,
      description: PropTypes.string,
      onRequestClose: PropTypes.func,
    }),
  }

  onCheckboxChange(type, event) {
    this.props.onChangeFilter(type, event)
  }

  getClass() {
    var fixed = {}
    fixed[styles.fixed] = this.props.data.isFixed
    return classnames(styles.popover, fixed)
  }

  render() {
    let { data } = this.props

    return (
      <Popover
        open={data.isShown}
        anchorEl={data.anchor}
        container={data.isFixed ? document.body : data.container}
        placement="bottom"
        className={this.getClass()}
        onRequestClose={this.props.close}>
        {this.props.filterItems.map((item, index) => {
          return (
            <div className={styles.filterItem} key={index}>
              <Checkbox
                label={item.value}
                onChange={this.onCheckboxChange.bind(this, item.type)}
                checked={item.checked}
                className={styles.filterCheckbox}
                dataQa={`filter-${index}`}
              />
            </div>
          )
        })}
      </Popover>
    )
  }
}

export default Filter
